
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import productionService from '../../services/productionService';

export const fetchEWOs = createAsyncThunk('production/fetchEWOs', async (_, { getState }) => {
  return await productionService.getEWOs(getState().auth.token);
});
export const fetchMaterialOrders = createAsyncThunk('production/fetchMaterialOrders', async (_, { getState }) => {
  return await productionService.getMaterialOrders(getState().auth.token);
});
export const fetchPettyCash = createAsyncThunk('production/fetchPettyCash', async (_, { getState }) => {
  return await productionService.getPettyCash(getState().auth.token);
});
export const createEWO = createAsyncThunk('production/createEWO', async (data, { getState }) => {
  return await productionService.createEWO(data, getState().auth.token);
});

const productionSlice = createSlice({
  name: 'production',
  initialState: {
    ewoList: [], materialOrders: [], pettyCash: [],
    loading: false, error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEWOs.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchEWOs.fulfilled, (state, action) => { state.loading = false; state.ewoList = action.payload; })
      .addCase(fetchEWOs.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchMaterialOrders.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchMaterialOrders.fulfilled, (state, action) => { state.loading = false; state.materialOrders = action.payload; })
      .addCase(fetchMaterialOrders.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchPettyCash.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchPettyCash.fulfilled, (state, action) => { state.loading = false; state.pettyCash = action.payload; })
      .addCase(fetchPettyCash.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createEWO.fulfilled, (state, action) => { state.ewoList.unshift(action.payload); });
  },
});

export default productionSlice.reducer;
